import { mpfRListsHttp } from '../../api/mpf-r-lists-http'
import { isArchivedFilter } from '../data'

interface InquiryProcessFlowMetadata {
  AssignTo: boolean
  AssignToOptions: string
  Cancel: boolean
  Close: boolean
  CustomerActionComplete: boolean
  CustomerActionRequired: boolean
  Elevate: boolean
  ElevateToOptions: string
  PendingActionComplete: boolean
  PendingActionOutside: boolean
  Reopen: boolean
  Resolve: boolean
  Respond: boolean
  Role: string
  Section: string
  StatusCode: string
  UserType: string
}
interface InquiryProcessFlowMetadataArgs {
  isArchivedFilter: false | null | true
  isAscending?: boolean
  orderBy?: string
}
const COLUMN_NAMES = {
  AssignTo: 'AssignTo',
  AssignToOptions: 'AssignToOptions',
  Cancel: 'Cancel',
  Close: 'Close',
  CustomerActionComplete: 'CustomerActionComplete',
  CustomerActionRequired: 'CustomerActionRequired',
  Elevate: 'Elevate',
  ElevateToOptions: 'ElevateToOptions',
  PendingActionComplete: 'PendingActionComplete',
  PendingActionOutside: 'PendingActionOutside',
  Reopen: 'Reopen',
  Resolve: 'Resolve',
  Respond: 'Respond',
  Role: 'Role',
  Section: 'Section',
  StatusCode: 'StatusCode',
  UserType: 'UserType',
}
const LIST_NAME = 'InquiryProcessFlowMetadataList'
const getInquiryProcessFlowMetadata = async (
  args: InquiryProcessFlowMetadataArgs
): Promise<InquiryProcessFlowMetadata[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = isArchivedFilter(args.isArchivedFilter)
  const ascending = args?.isAscending ?? true
  const orderBy = args?.orderBy ?? COLUMN_NAMES.StatusCode

  const items = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.AssignTo,
      COLUMN_NAMES.AssignToOptions,
      COLUMN_NAMES.Cancel,
      COLUMN_NAMES.Close,
      COLUMN_NAMES.CustomerActionComplete,
      COLUMN_NAMES.CustomerActionRequired,
      COLUMN_NAMES.Elevate,
      COLUMN_NAMES.ElevateToOptions,
      COLUMN_NAMES.PendingActionComplete,
      COLUMN_NAMES.PendingActionOutside,
      COLUMN_NAMES.Reopen,
      COLUMN_NAMES.Resolve,
      COLUMN_NAMES.Respond,
      COLUMN_NAMES.Role,
      COLUMN_NAMES.Section,
      COLUMN_NAMES.StatusCode,
      COLUMN_NAMES.UserType
    )
    .orderBy([{ ascending: ascending, orderBy: orderBy }])
    .get()

  return [...items] as InquiryProcessFlowMetadata[]
}

export {
  COLUMN_NAMES,
  type InquiryProcessFlowMetadata,
  type InquiryProcessFlowMetadataArgs,
  LIST_NAME,
  getInquiryProcessFlowMetadata,
}
